import styled from "styled-components";

export const Corouselresponsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 6,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const WebCorouselresponsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 580 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 580, min: 0 },
    items: 1,
  },
};
export const ProductModalContainer = styled.div`
  padding: 20px;
  text-align: center;
  display: flex;
  background-color: var(--blackgrey);
  height: 94%;
  flex-direction: column;

  & > h2 {
    padding: 15px 10px 10px 10px;
    color: black;
    font-size: 20px;
    text-align: center;
    overflow: hidden;
    color: var(--secondary);
  }
  & > h3 {
    color: black;
    text-align: center;
    overflow: hidden;
    color: var(--secondary);
    font-size: 12px;
  }
  & > h4 {
    padding: 8px 10px 10px 10px;
    color: var(--blackgrey);
    text-align: center;
    font-size: 12px;
    text-align: center;
    overflow: hidden;
    color: var(--secondary);
  }
`;

export const CorouselContainer = styled.div`
  padding-top: 50px;

  @media (max-width: 768px) {
    padding-top: 30px;
  }
`;

export const ImageContainer = styled.img`
  position: relative;
  border-radius: 10px;
  transition: 0.5s ease;
  backface-visibility: hidden;
  overflow: hidden;
  height: 100%;
  width: 140px;
  object-fit: cover;
`;

export const WebImageContainer = styled.img`
  position: relative;
  border-radius: 10px;
  transition: 0.5s ease;
  backface-visibility: hidden;
  overflow: hidden;
  height: 100%;
  width: 350px;
  object-fit: cover;
  @media (max-width: 1330px) {
    width: 300px;
  }
  @media (max-width: 1230px) {
    width: 250px;
  }
  @media (max-width: 700px) {
    width: 200px;
  }
  @media (max-width: 580px) {
    width: 350px;
  }
`;
export const CloseButton = styled.a`
  position: absolute;
  top: 10px;
  right: 10px;
  height: 25px;
  width: 25px;
  padding: 3px;
  border-radius: 50%;
  &:hover {
    transition: all 0.3s ease-out;
    background-color: var(--hoverback);
    color: var(--primary);
  }
`;

export const CloseRight = styled.div`
  height: 20px;
  width: 2px;
  margin-left: 12px;
  margin-top: 2.3px;
  background-color: var(--secondary);
  transform: rotate(45deg);
  z-index: 1;
`;

export const CloseLeft = styled.div`
  height: 20px;
  width: 2px;
  background-color: var(--secondary);
  transform: rotate(90deg);
  z-index: 2;
`;
